import { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { DailyPickupsSummary, ParcelsLineHaulCount } from '../types/statsTypes';
import {
  fetchDailyPickupsSummary,
  fetchLineHaulSortingSummary,
} from '../fetch/fetchStats';

export function useGetDailyPickupsSummary(): {
  pickupsSummary: DailyPickupsSummary;
  pickupsLoading: boolean;
} {
  const [pickupsLoading, setPickupsLoading] = useState<boolean>(true);
  const [pickupsSummary, setPickupsSummary] =
    useState<DailyPickupsSummary>(null);

  useEffect(() => {
    const fetchPickupsCount = async () => {
      const today = dayjs();
      const pickups = await fetchDailyPickupsSummary(today);
      setPickupsSummary(pickups);
      setPickupsLoading(false);
    };

    fetchPickupsCount();
  }, [setPickupsSummary, setPickupsLoading]);

  return { pickupsSummary, pickupsLoading };
}

export function useGetDailyLineHaulSummary(forDate: Dayjs): {
  parcelsLineHaulSummary: ParcelsLineHaulCount[];
  lineHaulSummaryLoading: boolean;
} {
  const [lineHaulSummaryLoading, setLineHaulSummaryLoading] =
    useState<boolean>(true);
  const [parcelsLineHaulSummary, setParcelsLineHaulSummary] =
    useState<ParcelsLineHaulCount[]>(null);

  const dateAsString = forDate.format('YYYY-MM-DD');

  useEffect(() => {
    const fetchPickupsCount = async () => {
      const parcelsLineHaulCount = await fetchLineHaulSortingSummary(
        dateAsString
      );
      setParcelsLineHaulSummary(parcelsLineHaulCount);
      setLineHaulSummaryLoading(false);
    };

    fetchPickupsCount();
  }, [dateAsString, setLineHaulSummaryLoading]);

  return { parcelsLineHaulSummary, lineHaulSummaryLoading };
}
